<template>
	<div style="background-color: #fcfcfc;" ref="scrollContainer" @scroll="getScrollDistance">
		<div style="background-color: #fff;position: fixed;width: 100%;box-shadow: 0in 2.25pt 3.75pt;transition: opacity 2s ease-in;z-index: 999; ">
			<Myheaderesa></Myheaderesa>
		</div>
		<div style="height: 60px;"></div>
		<div class="course" style="margin-bottom: 60px;">
			<div style="width: 100%;margin-bottom: 30px;overflow: hidden;"><img style="width: 100%;" src="@/images/banner.png?v=1.0.0.0" alt="" /></div>
			<div class="courseli">
				<div class="fliters fleys">
					<ul class="flexs " style="align-items: flex-start;position: relative;">
						<li class="fliterstitle" style="margin-top: 5px;">专业</li>

						<div
							class="flexs"
							ref="changeszy"
							:style="{ height: iszymore ? 'auto' : '40px' }"
							style="margin-left: 5px;width: 90%; flex-wrap: wrap;height: 40px;overflow: hidden;"
						>
							<li
								style="margin-top: 5px;"
								:class="{ choiceactive: zyguid == '' }"
								@click="
									zyguid = '';
									getpositionlist();
									gettionsTypenum();
								"
							>
								全部
							</li>
							<li style="margin-top:5px;" v-for="(item, index) in zylist" :key="index" @click="changezy(item)" :class="{ choiceactive: item.pro_guid == zyguid }">
								{{ item.pro_name }}
							</li>
						</div>
						<div class="morebtn" style="margin-left: auto;" @click="changemore(1)"><i class="el-icon-arrow-down"></i></div>
					</ul>
					<ul class="flexs" style="flex-wrap: wrap;align-items: flex-start;">
						<li class="fliterstitle">岗位</li>
						<li style="width: 80%;">
							<div class="flexs" ref="changesgw" :style="{ height: isgwmore ? 'auto' : '40px' }" style="flex-wrap: wrap;height: 40px;overflow: hidden;">
								<li
									:class="{ choiceactive: gwguid == '' }"
									@click="
										gwguid = '';
										gettionsTypenum();
									"
								>
									全部
								</li>
								<li
									v-for="(item, index) in gwlist"
									:key="index"
									@click="
										gwguid = item.PR_GUID;
										gettionsTypenum();
									"
									:class="{ choiceactive: gwguid == item.PR_GUID }"
								>
									{{ item.PR_ProfessionalName }}
								</li>
							</div>
						</li>
						<div class="morebtn" style="margin-left: auto;margin-top: 8px;" @click="changemore(2)"><i class="el-icon-arrow-down"></i></div>
					</ul>
					<ul class="flexs">
						<li class="fliterstitle">等级</li>
						<li
							style="    margin-left: 10px;"
							:class="{ choiceactive: djguid == '' }"
							@click="
								djguid = '';
								gettionsTypenum();
							"
						>
							全部
						</li>
						<li
							v-for="(item, index) in djlist"
							:key="index"
							@click="
								djguid = item.IL_GUID;
								gettionsTypenum();
							"
							:class="{ choiceactive: djguid == item.IL_GUID }"
						>
							{{ item.IL_LevelTitle }}
						</li>
					</ul>
				</div>
				<div class="fliterschoice flexs">
					<div class="flexs">
						<p>单选题：</p>
						<p style="color: green;">{{ QusetionsType.SingleCount }}道</p>
						<p>多选题：</p>
						<p style="color: red;">{{ QusetionsType.MultipleCount }}道</p>
						<p>判断题：</p>
						<p style="color: red;">{{ QusetionsType.JudgeCount }}道</p>
						<p>共：</p>
						<p style="color: green;">{{ QusetionsType.TotalCount }}道</p>
					</div>
					<p @click="$router.push('/usercenter/homesview/testists/Myexamind?radios=true')" style="color: red;font-size: 16px;text-decoration: underline;">
						前往我的练习记录
					</p>
				</div>
				<el-divider></el-divider>
				<div class="courselist flexs">
					<div :style="{ background: !isgotextsnum ? '#ccc' : '' }" class="courseitem fleys" @click="gotestists(1)">
						<div><img src="@/assets/img/texts.svg" alt="" /></div>
						<p>模拟考试</p>
						<p style="color: red;font-size: 14px;">请选择对应的专业、岗位、等级，才能进行考试练习</p>
					</div>
					<div class="courseitem fleys" @click="gotestists(2)">
						<div><img src="@/assets/img/random.svg" alt="" /></div>
						<p>随机练习</p>
						<p>随机抽题，自主控制题量</p>
					</div>
					<div class="courseitem fleys" @click="gotestists(3)">
						<div><img src="@/assets/img/tixingttest.svg" alt="" /></div>
						<p>题型练习</p>
						<p>理论考试题库</p>
					</div>
				</div>
			</div>

			<el-dialog title="选择题型" center :visible.sync="dialogVisible" :before-close="handleClose">
				<div class="textradioall">
					<div class="textradio">
						<p>练习题型</p>
						<el-radio-group v-model="quetypeid">
							<el-radio v-for="item in quetype" :key="item.SQT_GUID" :label="item.SQT_GUID">{{ item.SQT_Name }}</el-radio>
						</el-radio-group>
					</div>
					<div class="textradio">
						<p>练习模式</p>
						<el-radio-group v-model="radio">
							<el-radio :label="0">全部</el-radio>
							<el-radio :label="1">未做</el-radio>
							<el-radio :label="2">已做</el-radio>
							<el-radio :label="3">错题</el-radio>
						</el-radio-group>
					</div>
					<div class="textradio">
						<p>题目数量</p>
						<el-radio-group v-model="radionum">
							<el-radio :label="20">20</el-radio>
							<el-radio :label="50">50</el-radio>
							<el-radio :label="100">100</el-radio>
						</el-radio-group>
					</div>
				</div>

				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="gochioce(3)">开始做题</el-button></span>
			</el-dialog>
		</div>
		<Myfooters></Myfooters>
	</div>
</template>
<script>
import AppOptions from '../config/AppOptions.vue';

import Myheaderesa from '@/components/layout/headeresa.vue';

import Myfooters from '@/components/layout/footers.vue';

import {
	IspapercreateruleApi,
	getGetProfList,
	getPositionList,
	getInspectionlevel,
	getGetQusetionsTypeSum,
	getAjaxSimulationTraining,
	getGetQuetype
} from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	components: {
		Myheaderesa,
		Myfooters
	},
	data() {
		return {
			input1: '',
			zyguid: '',
			zylist: [],
			gwguid: '',
			gwlist: [],
			djguid: '',
			djlist: [],
			coureseobj: {
				pro_guid: '',
				IL_GUID: '',
				PR_GUID: ''
			},
			coureselist: [],
			couresetotle: 0,
			QusetionsType: {},
			dialogVisible: false,
			radio: 0,
			quetype: [],
			quetypeid: '',
			radionum: 20,
			iszymore: true,
			isgwmore: true,
			isgotextsnum: false
		};
	},
	created() {
		AppOptions.appEmpty = true;
	},
	// beforeRouteLeave(to, from, next) {
	// 	AppOptions.appEmpty = false;
	// 	next();
	// },
	mounted() {
		if (localStorage.getItem('token')) {
			this.init();
			// console.log('登录');
		} else {
			this.$router.push('/user/logins?typepath=3');
		}
	},
	updated() {
		// this.isgotexts();
	},
	methods: {
		// 判断是否可以考试
		async isgotexts() {
			let coureseobj = {
				pro_guid: '',
				IL_GUID: '',
				PR_GUID: ''
			};
			coureseobj.pro_guid = this.zyguid;
			coureseobj.IL_GUID = this.djguid;
			coureseobj.PR_GUID = this.gwguid;
			const datas = await IspapercreateruleApi(coureseobj);
			// console.log('获取data信息', datas.data.data);
			if (datas.data.data) {
				this.isgotextsnum = datas.data.data;
			} else {
				this.isgotextsnum = false;
			}
		},
		delectsdf() {
			localStorage.clear('token');
			localStorage.clear('siguid');
			localStorage.clear('uiguid');
			this.$cookie.remove('allbtnlist');
			// this.$cookie.remove('/%password/%');
			this.$cookie.remove('/%sxtrguid/%');
			// this.$cookie.remove('/%name/%');
			this.$cookie.remove('sxsi_guid');
			this.$cookie.remove('Token');

			this.delCookie();
			this.$cookie.remove('Token');
			this.$router.push({
				name: '登录'
			});
		},
		changemore(num) {
			// console.log(this.$refs.changeszy.style)
			if (num == 1) {
				this.iszymore = !this.iszymore;
				// if (this.iszymore) {
				// 	this.$refs.changeszy.style.height = 'auto';
				// } else {
				// 	this.$refs.changeszy.style.height = '40px';
				// }
			} else if (num == 2) {
				this.isgwmore = !this.isgwmore;
				// if (this.isgwmore) {
				// 	this.$refs.changesgw.style.height = 'auto';
				// } else {
				// 	this.$refs.changesgw.style.height = '40px';
				// }
			}
		},
		getScrollDistance() {
			// var scrollDistance = window.scrollY || document.documentElement.scrollTop;
			// console.log(scrollDistance);
			// console.log("滚动值");
		},
		handleClose(done) {
			done();
			// this.$confirm('确认关闭？')
			// 	.then(_ => {

			// 	})
			// 	.catch(_ => {});
		},
		gochioce(id) {
			this.$router.push({
				path:
					'/testists/testdelites?id=' +
					id +
					'&pro_guid=' +
					this.zyguid +
					'&IL_GUID=' +
					this.djguid +
					'&PR_GUID=' +
					this.gwguid +
					'&SQT_GUID=' +
					this.quetypeid +
					'&PracticeMode=' +
					this.radio +
					'&radionum=' +
					this.radionum
			});
		},
		gotestists(id) {
			if (id == 1) {
				this.coureseobj.pro_guid = this.zyguid;
				this.coureseobj.IL_GUID = this.djguid;
				this.coureseobj.PR_GUID = this.gwguid;
				getAjaxSimulationTraining(this.coureseobj).then(res => {
					// console.log(res,"获取题目")
					if (res.data.code == -1) {
						this.$massage('暂无题目，请选择其他专业');
					} else {
						this.$router.push({
							path: '/homesview/examinationmanage/examine?id=' + id + '&pro_guid=' + this.zyguid + '&IL_GUID=' + this.djguid + '&PR_GUID=' + this.gwguid
						});
					}
				});
			} else if (id == 2) {
				this.$router.push({
					path: '/testists/testdelites?id=' + id + '&pro_guid=' + this.zyguid + '&IL_GUID=' + this.djguid + '&PR_GUID=' + this.gwguid
				});
			} else {
				getGetQuetype().then(ress => {
					this.quetype = ress.data.data;
					this.quetypeid = ress.data.data[0].SQT_GUID;
					this.dialogVisible = true;
				});
			}
		},
		init() {
			this.getprolist();
			this.getinstionlevel();
			this.gettionsTypenum();
		},
		gettionsTypenum() {
			this.isgotexts();
			this.coureseobj.pro_guid = this.zyguid;
			this.coureseobj.PR_GUID = this.gwguid;
			this.coureseobj.IL_GUID = this.djguid;
			getGetQusetionsTypeSum(this.coureseobj).then(res => {
				// console.log(res)
				this.QusetionsType = res.data.data;
			});
		},
		gocoudetea() {
			this.$router.push('/cours/clouddetea');
		},
		// 专业
		getprolist() {
			getGetProfList().then(res => {
				this.zylist = res.data.data;
				this.getpositionlist();
			});
		},
		changezy(itm) {
			this.zyguid = itm.pro_guid;
			this.gwguid = '';

			this.getpositionlist();
			this.gettionsTypenum();
		},
		// 岗位
		getpositionlist() {
			var pro_guid = this.zyguid;
			getPositionList(pro_guid).then(res => {
				this.gwlist = res.data.data;
			});
		},
		// 等级
		getinstionlevel() {
			getInspectionlevel().then(res => {
				this.djlist = res.data.data;
			});
		}
	}
};
</script>

<style scoped lang="less">
.morebtn {
	color: #333;
	// border: 1px solid #ddd;
	float: left;
	margin-right: 10px;
	// position: absolute;
	// right: 0;
	width: 50px;
	height: 23px;
	line-height: 23px;
	padding: 0 7px 0 4px;
	background: #fff;
	margin-top: 8px;
	font-size: 16px;
	cursor: pointer;
	text-align: right;
}

.morebtn:hover {
	i {
		color: #0054ff;
	}
}

.textradioall {
	width: 100%;
	padding: 20px;

	.textradio {
		display: flex;
		align-items: center;
		margin: 20px 10px;

		p {
			width: 80px;
			margin-right: 20px;
		}
	}
}

.dialog-footer {
	width: 200px;

	button {
		width: 50%;
	}
}

.choiceactive {
	padding: 0 20px;
	border: 1px solid #0054ff;
	border-radius: 30px;
	background: #0054ff;
	color: #fff;
}

/deep/ .el-input {
	height: 30px;

	input {
		height: 100%;
	}

	.el-input__suffix {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.fliterschoice {
	justify-content: space-between;
	p {
		margin: 0 10px;
		cursor: pointer;
		font-size: 16px;
	}
	.titlesactive {
		color: #0054ff;
		font-weight: 700;
	}
}

/deep/ .el-divider--horizontal {
	margin: 15px 0;
}

.course {
	// min-width: 1400px;
	// width: 1400px;
	// margin: auto;
}

.flexs {
	display: flex;
	align-items: center;
}

.fleys {
	display: flex;
	flex-direction: column;
}

.fliters {
	background: #fff;
	padding: 10px;
	border-radius: 10px;
	font-size: 16px;
	box-shadow: 0px 0px 5px 0px #ccc;
	margin: 40px 0;
	ul {
		padding: 10px 0;
		border-bottom: 1px dashed #ccc;
		li {
			margin: 4px 15px 4px 5px;
			cursor: pointer;
		}
	}
	ul:last-child {
		border-bottom: none;
	}

	.fliterstitle {
		font-size: 18px;
		color: #000;
		margin-right: 5px;
		margin-top: 8px;
		width: 50px;
	}
}

/deep/ .el-pagination {
	display: flex;
	justify-content: center;
	align-items: center;
}

.courseitems {
	padding: 10px;
	background-color: #f5f5f5;
	height: 110px;
}

.courseli {
	min-width: 1200px;
	width: 1200px;
	margin: auto;
}

.coursefonts {
	font-size: 14px;
	color: #373c41;
	font-weight: 600;
}

.courselist {
	flex-wrap: wrap;

	.courseitemstudy {
		justify-content: space-between;
		margin: 10px 0;
	}

	.courseitem:nth-of-type(2) {
		div {
			background-color: #5e9ced;
		}
	}

	.courseitem:nth-of-type(3) {
		div {
			background-color: #4ec1e8;
		}
	}

	.courseitem:nth-of-type(2):hover {
		background-color: rgba(0, 0, 255, 0.2);
	}

	.courseitem:nth-of-type(2) {
		border-left: none;
		border-right: none;
	}

	.courseitem:nth-of-type(1):hover {
		background-color: rgba(128, 0, 128, 0.2);
	}

	.courseitem:nth-of-type(3):hover {
		background-color: rgba(193, 210, 240, 0.6);
	}

	.courseitem {
		width: 33.3%;
		// margin-right: 1%;
		border: 1px solid #ececec;
		border-radius: 4px;
		margin-bottom: 40px;
		overflow: hidden;
		height: 450px;
		justify-content: center;
		align-items: center;
		cursor: pointer;

		p:nth-of-type(1) {
			font-size: 18px;
			font-weight: 700;
			color: #000;
		}

		p:nth-of-type(2) {
			font-size: 16px;
		}

		div {
			width: 50px;
			height: 50px;
			margin-bottom: 10px;
			background-color: #ab92ed;
			padding: 10px;
			border-radius: 20px;
		}

		img {
			width: 100%;
		}
		img:hover {
			transform: scale(1.2);
			transition: all 2s;
		}
	}
}
</style>
